import { Flex } from 'styling/GlobalStyles'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { formatParams } from 'utils/helpers'
import { useState } from 'react'
import usePaginate from 'hooks/usePaginate'
import { Title } from 'components/Dashboard/Title'
import { DashboardModalArrow, DashboardModalContainer, DashboardModalContent, DashboardModalWrapper } from 'pages/Dashboard/Dashboard.styled'
import { InfoIcon } from 'assets/icons/InfoIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { endOfWeek, startOfWeek } from 'date-fns'
import { IGetFuelAlertsResponse } from 'types/api/fuelManagementApi.interface'
import { tokens } from 'styling/tokens'
import { fuelAlertPriorities, fuelAlertRiskLevels } from './fuelData'
import { ALERT_KIND_TO_UI, ALERT_LATENCY_TO_UI } from './Shared/fuelEnumMaps'

export const FuelAlertsModal = ({ closeModal }) => {
  const [params, setParams] = useState({
    dateFrom: startOfWeek(new Date(), { weekStartsOn: 1 }),
    dateTo: endOfWeek(new Date(), { weekStartsOn: 1 }),
  })
  const [list, setList] = useState<IGetFuelAlertsResponse['alerts']>([])
  const [loading, setLoading] = useState(false)

  const parserFunction = (data: IGetFuelAlertsResponse) => data.alerts

  usePaginate('fuel/management/dashboard/fuel/alert', formatParams(params), null, parserFunction, setList, null, null, true, true, null, setLoading)

  const columns: IHonestTableColumn<any>[] = [
    { id: 'summary', header: 'Summary', cell: (n) => <span title={n.summary}>{n.summary}</span> },
    { id: 'kind', header: 'Kind', cell: (n) => (n.kind != null ? ALERT_KIND_TO_UI[n.kind] : '/') },
    { id: 'risk', header: 'Risk', cell: (n) => fuelAlertRiskLevels[n.riskLevel] || '/' },
    { id: 'priority', header: 'Priority', cell: (n) => fuelAlertPriorities[n.priority] || '/' },
    { id: 'machine', header: 'Machine', cell: (n) => n.machine?.name || '/' },
    { id: 'site', header: 'Site', cell: (n) => n.site?.name || '/' },
    { id: 'latency', header: 'Latency', cell: (n) => (n.latency != null ? ALERT_LATENCY_TO_UI[n.latency] : '/') },
    { id: 'confidence', header: 'Confidence', cell: (n) => `${Math.round(n.confidence * 100)}%` },
    { id: 'zscore', header: 'Z-Score', cell: (n) => n.dispenseRateZscore ?? '/' },
  ]

  return (
    <DashboardModalWrapper>
      <DashboardModalContainer style={{ width: screen.availWidth < 500 ? '100%' : '60vw' }}>
        <Flex width='100%' gap='1rem' style={{ margin: '2rem 0' }}>
          <DashboardModalArrow onClick={closeModal}>
            <ArrowLeft />
          </DashboardModalArrow>
          <Title
            center
            mainIcon={<InfoIcon />}
            height={'fit-content'}
            title='Alerts'
            color={tokens.status.danger.fg}
            rightSide={(
              <Flex gap='1rem' center>
                <CalendarInput
                  maxDate={new Date(params.dateTo)}
                  labelText='Start date'
                  defaultValue={params.dateFrom}
                  onChange={(v) => setParams((p) => ({ ...p, dateFrom: v }))}
                />
                <CalendarInput
                  minDate={new Date(params.dateFrom)}
                  labelText='End date'
                  defaultValue={params.dateTo}
                  onChange={(v) => setParams((p) => ({ ...p, dateTo: v }))}
                />
              </Flex>
            )}
          />
        </Flex>
        <DashboardModalContent width='100%'>
          {loading ? null : list.length ? (
            <HonestTable columns={columns} data={list} keyField='id' />
          ) : (
            <NoItems title='Alerts' />
          )}
        </DashboardModalContent>
      </DashboardModalContainer>
    </DashboardModalWrapper>
  )
}
